<ion-content>
  <ion-refresher
    id="refresher"
    slot="fixed"
    (ionRefresh)="doRefresh($event)"
    [disabled]="!this.platform.is('capacitor')"
  >
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-grid class="pb-[5em] max-w-prose m-auto">
    <ion-row>
      <ion-col>
        <app-info-varsling-popup
          *ngFor="let i = index; let message; of: infoMessages"
          [popupId]="i"
          [message]="message"
        ></app-info-varsling-popup>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-title [class.desktop]="this.platform.is('desktop')">
          <h1>Din analyse*</h1>
        </ion-title>
        <p
          class="bg-white p-2 mb-4 rounded-xl shadow-lg ion-text-center max-md:mx-2"
        >
          *Vi tester ut ny funksjonalitet og det vil komme endringer
          fortløpende. Vi tar forbehold om feil.
        </p>
      </ion-col>
    </ion-row>

    @if (!loading && !valgtAvtale && !valgtAnlegg) {
    <ion-row>
      <ion-col class="ingen-avtale-boks mt-4">
        <p>Vi finner ingen aktive avtaler for din bruker.</p>
      </ion-col>
    </ion-row>
    } @else {
    <ion-row>
      <ion-col>
        <app-anlegg
          [_showAnleggsliste]="_showAnleggsliste"
          [anleggList]="anleggList"
          [valgtAnlegg]="valgtAnlegg"
          [anleggIsInactive]="anleggIsInactive"
          [mineAvtaler]="mineAvtaler"
          (outAnlegg)="setAnlegg($event)"
        ></app-anlegg>
      </ion-col>
    </ion-row>

    @if (loading) {
    <ion-row>
      <ion-col class="text-center">
        <ion-spinner name="dots"></ion-spinner>
      </ion-col>
    </ion-row>
    } @else {
    <app-analyse-dashboard
      [analyzedConsumption]="analyzedConsumption"
      [smartScore]="smartScore"
      [currentHighThreeDayMax]="currentHighThreeDayMax"
      [errorAnalyse]="errorAnalyse"
      [errorScore]="errorScore"
      [hasNoConfig]="hasNoConfig"
      [netteier]="netteier"
      [valgtAnlegg]="valgtAnlegg"
      [meteorologyObservations]="meteorologyObservations"
      [meteorologyForecast]="meteorologyForecast"
    ></app-analyse-dashboard>
    }
    <ion-row>
      <ion-col class="text-center mx-4 max-w-prose">
        <p class="mt-0">
          I analysen ønsker vi å gi deg informasjon om ditt forbruk, og gi gode
          tips og råd hvis vi ser at du med små grep kan spare penger. For å se
          flere detaljer i hver kategori kan du gå videre inn på
          nettleieanalysen og forbruksanalysen.
        </p>
        <p>
          Gjerne gi oss tilbakemelding under om du har innspill til
          forbedringer.
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-customer-feedback></app-customer-feedback>
      </ion-col>
    </ion-row>
    }
  </ion-grid>
</ion-content>
